<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items">
        <template v-slot:item.no="{ item }">
          {{ items.map(x => x).indexOf(item) + 1 }}
        </template>
        <template v-slot:item.invoiceAmount="{ item }">
          {{ formatPrice(item.invoiceAmount) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn color="success" @click="convert(item)">convert</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "buffer-invoice-pdf",
  data() {
    return {
      items: [],
      files: [],
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Vendor",
          value: "vendorName",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Invoice#",
          value: "invoiceNumber",
          sortable: false,
          align: "center",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Date",
          value: "invoiceDate",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "PO#",
          value: "referenceNumber",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "DPP",
          value: "invoiceAmount",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    async getBufferInvoicePdf() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseInvoice/getBufferInvoicePdfs")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    convert(item) {
      const routeData = this.$router.resolve({
        name: "Create Purchase Invoice From Buffer",
        params: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.getBufferInvoicePdf();
  },
};
</script>

<style scoped></style>
